
// Firebase
export const FB_INIT = 'FB_INIT'
export const FB_OBJECT = 'FB_OBJECT'
export const FB_ARRAY = 'FB_ARRAY'
export const FB_ADD = 'FB_ADD'
export const FB_CHANGE = 'FB_CHANGE'
export const FB_MOVE = 'FB_MOVE'
export const FB_REMOVE = 'FB_REMOVE'

// Nav
export const NAV_TOGGLE = 'NAV_TOGGLE'

// Content
export const LOAD_CONTENT = 'LOAD_CONTENT'
export const UNLOAD_CONTENT = 'UNLOAD_CONTENT'
export const LOAD_ITEM = 'LOAD_ITEM'
export const UNLOAD_ITEM = 'UNLOAD_ITEM'
export const SET_LOADING = 'SET_LOADING'
export const SET_PAGE = 'SET_PAGE'
export const SET_PAGE_LIMIT = 'SET_PAGE_LIMIT'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_SORT_FIELD = 'SET_SORT_FIELD'

// Model
export const UNLOAD_MODEL = 'UNLOAD_MODEL'
export const UNLOAD_MODELS = 'UNLOAD_MODELS'

// Users
export const CREATE_USER = 'CREATE_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export const SET_SITE = 'SET_SITE'
export const UNSET_SITE = 'UNSET_SITE'
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL'
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD'
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE'
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD'



// WEBPACK FOOTER //
// ./src/lib/store/types.js